import React from 'react';

import OrgLayoutContainer from '@totem/components/orgManagement/layout/orgLayoutContainer';
import OrgManagementLayout from '@totem/components/orgManagement/layout/orgManagementLayout';
import OrgContainer from '@totem/components/orgManagement/orgContainer';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const OrgManagementPage = () => {
  return (
    <ContentLayout>
      <OrgLayoutContainer>
        <OrgContainer>
          <OrgManagementLayout />
        </OrgContainer>
      </OrgLayoutContainer>
    </ContentLayout>
  );
};

export default OrgManagementPage;
